import React from 'react';

import {BaseProps} from "../../../../../infrastructure/models/props/base-props";
import {GameCenterHeaderModuleController} from "../game-center-header-module.controller";
import {RectangleLabel} from "../../../../../core/components/misc/rectangle-label/rectangle-label";
import styles from "../styles/game-center-header.module.scss";

export class GameCenterHeaderModuleSpreadProps extends BaseProps {
  controller: GameCenterHeaderModuleController;
}

export const GameCenterHeaderModuleSpread = ({controller, className}: GameCenterHeaderModuleSpreadProps) => {
  const {state} = controller;
  const {device, spread, shouldDisplaySpread} = state;

  const spreadProps = {
    device,
    className,
    isVisible: spread,
    colorLabelClassName: styles.spread
  };

  return (
    shouldDisplaySpread ? <RectangleLabel {...spreadProps}>{spread}</RectangleLabel> : null
  )
};
